import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    spinnerBox: {
      display: 'flex',
      justifyContent: 'center'
    }
  })
);

export interface LoaderProps {
  isLoading: boolean;
  size?: string | number | undefined;
}

function Loader({ isLoading, size }: LoaderProps) {
  const classes = useStyles();
  return isLoading ? (
    // TODO: Check if needed to send 'xs' property via props too
    <Grid item xs={12} className={classes.spinnerBox}>
      <CircularProgress size={size} id="load-spinner" />
    </Grid>
  ) : null;
}

export default Loader;
